import React from 'react';
import './ExampleCard.css';
import { useDarkMode } from "src/context/DarkModeContext";
import { Card, Typography } from 'antd';
import { Example } from '../../../data/models/ExampleModel';

const { Paragraph } = Typography;

interface ExampleCardProps {
    example: Example;
}

const ExampleCard: React.FC<ExampleCardProps> = ({ example }) => {
    const { isDarkMode } = useDarkMode();
    return (
        <Card className={`example-card ${isDarkMode ? 'dark' : 'light'}`}>
            <Paragraph className={`example-card-sentence ${isDarkMode ? 'dark' : 'light'}`}>
                {example.sentence}
            </Paragraph>
            <Paragraph className={`example-card-explanation ${isDarkMode ? 'dark' : 'light'}`}>
                {example.explanation}
            </Paragraph>
        </Card>
    );
};

export default ExampleCard;
